import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import Glyphicon from "../Glyphicon";

class InfoWindowPrzewodniki extends PureComponent<any> {
  render() {
    const { guides, name } = this.props;
    if (!guides || guides.length === 0) return null;
    return (
      <section className="InfoWindowPrzewodniki">
        <Glyphicon className="InfoWindowPrzewodniki_icon" icon="explore" />
        {guides.length > 1 ? "Przewodniki" : "Przewodnik"}:{" "}
        <ul className="InfoWindowPrzewodniki_list">
          {guides.map((guide: any) => (
            <li key={guide.link}>
              <a
                href={guide.link}
                title="Zobacz przewodnik"
                className="InfoWindowPrzewodniki_link"
              >
                {name}
              </a>
            </li>
          ))}
        </ul>
      </section>
    );
  }
}

export default InfoWindowPrzewodniki;
